module.exports = __webpack_public_path__ + "static/media/bg-meditations-trees3x.2a33e8b9.png";